/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";

import { useFormContext } from "react-hook-form";
import styled from "styled-components";

import {
  Box,
  Button,
  Column,
  Columns,
  Strong,
  Text,
} from "@origin-digital/ods-core";
import { IconNewWindow } from "@origin-digital/ods-icons";
import { task } from "@origin-digital/reporting-client";

import {
  EllipsisTextLink,
  StyledHeading,
  TextLinkWithNoUnderline,
} from "@/components";
import { ANALYTICS_FORM_NAME, ANALYTICS_TASK_TYPE_MAP } from "@/constants";
import { IISelectedProvider } from "@/contract/generated/electrify-v1";
import { formatLabel } from "@/utils";

import { confirmation } from "./content.json";

// @ts-ignore
const StyledBox = styled(Box)(() => ({
  "&&": {
    "&.limit-max-width": {
      maxWidth: 386,
    },
  },
}));

// @ts-ignore
const StyledImageContainer = styled.div(() => ({
  "&&": {
    maxWidth: 168,
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",

    "& .service-provider-logo": {
      width: "100%",
      height: "auto",
    },
  },
}));

export const Confirmation = () => {
  const { getValues, setValue } = useFormContext();
  const selectedServiceProviders: Array<IISelectedProvider> = getValues(
    "selectedServiceProviders"
  );
  const serviceProviderNames: (string | undefined)[] =
    selectedServiceProviders.map((provider) => provider.providerName);

  useEffect(() => {
    const type = getValues("systemType");
    setValue("didFinishSolarForm", true);
    task.base(ANALYTICS_TASK_TYPE_MAP[type], {
      action: "complete",
      formName: ANALYTICS_FORM_NAME,
      serviceProviderNames,
    });
  }, []);

  return (
    <>
      <>
        <StyledHeading>{confirmation.heading}</StyledHeading>
        <Text>
          {formatLabel(
            confirmation.description,
            (value) => (
              <b>{value}</b>
            ),
            "one business day"
          )}
        </Text>
      </>
      <br />
      <Text>{confirmation.customerContact.label}</Text>
      <br />
      <Columns collapseBelow="sm" space={["medium", "large"]}>
        {selectedServiceProviders.map(
          ({ id, providerName, logoUrl, website, phone }) => {
            const websiteWithProtocol = website?.includes("http")
              ? website
              : `https://${website}`;

            return (
              <Column data-id={id} key={id}>
                <StyledBox
                  data-id={`${id}-wrapper-box`}
                  className={
                    selectedServiceProviders.length === 1
                      ? "limit-max-width"
                      : ""
                  }
                  border="1px solid #e3e3e3"
                  borderRadius="large"
                  display="flex"
                  flexDirection="column"
                  padding={["medium", "large"]}
                >
                  <StyledImageContainer className="styled-image-container">
                    <img
                      className="service-provider-logo"
                      src={logoUrl}
                      alt={providerName}
                    />
                  </StyledImageContainer>
                  <br />
                  <StyledHeading variant="h4" tone="neutralDark" weight="bold">
                    {providerName}
                  </StyledHeading>
                  <Text weight="medium">
                    <EllipsisTextLink
                      data-id={`${id}-${providerName}-website`}
                      href={websiteWithProtocol}
                      target="_blank"
                    >
                      {websiteWithProtocol}
                    </EllipsisTextLink>
                  </Text>
                  <Text weight="medium">
                    <TextLinkWithNoUnderline href={`tel:${phone}`}>
                      {phone}
                    </TextLinkWithNoUnderline>
                  </Text>
                </StyledBox>
              </Column>
            );
          }
        )}
      </Columns>
      <br />
      <>
        <Text variant="subtitle-small">
          <Strong>{confirmation.tellUs.label}</Strong>
        </Text>
        <Text>{confirmation.tellUs.description}</Text>
      </>
      <br />
      <div>
        <Button
          muiProps={{ endIcon: <IconNewWindow color="white" /> }}
          href={confirmation.giveFeedback.url}
        >
          {confirmation.giveFeedback.label}
        </Button>
      </div>
      <br />
      <>
        <Text variant="subtitle-small">
          <Strong>{confirmation.anyQuestions.label}</Strong>
        </Text>
        <Text>{confirmation.anyQuestions.description}</Text>
      </>
    </>
  );
};
